enum TrackingType {
  HUBSPOT = "HUBSPOT"
}

export default TrackingType;
